(function () {
  'use strict';

  if (typeof window.narika === 'undefined') {
    var narika = function () {
    };

    if (typeof exports !== 'undefined') {
      exports.narika = narika;
    }

    if (typeof window !== 'undefined') {
      window.narika = narika;
    } else if (typeof global !== 'undefined') {
      global.narika = narika;
    }
  }
  var narika = window.narika;

  // 環境によって変更する部分
  // var REST_API_ROOT_URL = 'http://localhost:8080';  // Rest API のROOT URLを記載します。
  // var REST_API_ROOT_URL = 'http://localhost:8080/narika_product_server';  // Rest API のROOT URLを記載します。
  // var CSCART_ROOT_URL = 'http://localhost/cscart411_2'; // CS Cart のROOT URLを記載します。
  // var REST_API_ROOT_URL = 'https://dev-scibox.narika.jp/narika_product_api';  // Rest API のROOT URLを記載します。
  // var CSCART_ROOT_URL = 'https://dev-scibox.narika.jp'; // CS Cart のROOT URLを記載します。
  var REST_API_ROOT_URL = 'https://www.scibox.jp/narika_product_api';  // Rest API のROOT URLを記載します。
  var CSCART_ROOT_URL = 'https://www.scibox.jp'; // CS Cart のROOT URLを記載します。
  var PRODUCT_WORDPRESS_SLAG_URL = 'product'; // 商品ページ（固定ページ）に設定されているWordPressのURLスラッグ
  var PRODUCT_PAGE_URL = '../' + PRODUCT_WORDPRESS_SLAG_URL; // 検索ページから見て、商品ページの相対URLを記載します。
  // 環境によって変更する部分 - ここまで

  var GET_PRODUCT_API_URL = REST_API_ROOT_URL + '/api/product/getProduct';
  var SEARCH_PRODUCTS_API_URL = REST_API_ROOT_URL + '/api/product/getProductList';
  var GET_PRODUCT_PDF_URL = REST_API_ROOT_URL + '/api/product/getProductPDF';

  narika.definition = {
    SUCCESS: 200,
    GET_PRODUCT_API_URL: GET_PRODUCT_API_URL,
    SEARCH_PRODUCTS_API_URL: SEARCH_PRODUCTS_API_URL,
    GET_PRODUCT_PDF_URL: GET_PRODUCT_PDF_URL,
    // cscartの商品へのURLは、旧URL で指定している。cscart側で自動的にリダイレクトされる。
    SCIBOX_PRODUCT_URL: CSCART_ROOT_URL + '/index.php?dispatch=products.view&product_id=',
    PRODUCT_PAGE_URL: PRODUCT_PAGE_URL,
    PRODUCT_WORDPRESS_SLAG_URL: PRODUCT_WORDPRESS_SLAG_URL,
    REQUEST_SOURCE_RIKA: '0',
  }

  module.exports = narika;

})();